<script>
  import { TableColumn } from 'element-ui'
  export default {
    name:'ElTableColumn',
    extends:TableColumn
  }
</script>
